module.exports = __webpack_public_path__ + "media/images/unsplash_attribution-df313f8134c74c4f202fc51023259b40.png";